import { routes } from "common/routes/routes";
import { Help, UserProfile } from "common/ui-components/index";
import { NavBarSettings } from "common/ui-components/NavBarSettings";
import { FC, ReactNode } from "react";
import { useNavigate } from "react-router-dom";

import { Header, HeaderProps, mergeStyleSets, Stack } from "@bps/fluent-ui";

export interface NavBarBaseProps {
  headerProps?: Partial<HeaderProps>;
  centerNavButtons?: ReactNode;
  /*Leftmost button*/
  beforeNavButtons?: ReactNode;
}

export const NavBarBase: FC<NavBarBaseProps> = ({
  centerNavButtons,
  headerProps,
  beforeNavButtons
}) => {
  const navigate = useNavigate();

  const isSettingsRoute = location.pathname.startsWith("/settings/");

  const {
    styles: headerStyles,
    logoProps,
    ...restHeaderProps
  } = headerProps ?? {};
  return (
    <Header
      hoverEffectItems
      logoProps={{
        text: "Premier Online Services",
        onClick: () => navigate(routes.appointmentBooking.locationEdit.path),
        ...logoProps
      }}
      styles={mergeStyleSets(
        {
          logo: { minHeight: 32, minWidth: 22 },
          root: {
            minHeight: 44
          },
          navItems: { flexGrow: 1, justifyContent: "space-between" }
        },
        headerStyles
      )}
      userBox={
        <>
          <Help />
          {!isSettingsRoute && <NavBarSettings />}
          <UserProfile />
        </>
      }
      {...restHeaderProps}
    >
      {beforeNavButtons}
      {centerNavButtons && (
        <>
          <Stack styles={{ root: { marginLeft: "auto" } }} />
          {centerNavButtons}
        </>
      )}
      <Stack styles={{ root: { marginLeft: "auto" } }} />
    </Header>
  );
};
